import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';

import ModificationDateBlockData from './Data';
import ModificationDateBlockView from './View';

const ModificationDateBlockEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;
  return (
    <>
      <ModificationDateBlockView {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <ModificationDateBlockData
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(ModificationDateBlockEdit);
